export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#F8F6F0] border-t border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/01cfeae8802c72fb1085873b8b9f4019/447f1458618ef8d5880dd2c7ce622bf2.jpeg"
                alt="Instituto Ashaika"
                className="h-12 w-auto object-contain rounded-md"
              />
              <span className="font-bold text-xl text-[#0A1F44]" style={{ fontFamily: "'Playfair Display', serif" }}>
                Instituto Ashaika
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-sm">
              Institución líder en formación de terapias alternativas en México. Transformamos vidas a nivel físico, emocional y energético desde hace más de 15 años.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com/alonso_ashaika/" },
                { icon: "ri-facebook-circle-line", label: "Facebook", href: "https://www.facebook.com/Ashtair.Ashaika/" },
                { icon: "ri-youtube-line", label: "YouTube", href: "https://youtube.com/channel/UC-4Sh1ohGBnO-6trq-sw6LA/" },
                { icon: "ri-tiktok-line", label: "TikTok", href: "https://www.tiktok.com/@dralonsoashaika" },
                { icon: "ri-whatsapp-line", label: "WhatsApp", href: "https://wa.me/523325077743" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-[#0A1F44]/20 text-[#0A1F44] hover:bg-[#0A1F44] hover:text-white hover:border-[#0A1F44] transition-all duration-300 cursor-pointer"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-[#0A1F44] font-bold text-sm uppercase tracking-widest mb-5">Navegación</h4>
            <ul className="space-y-3">
              {[
                { label: "Inicio", href: "#inicio" },
                { label: "Sobre Nosotros", href: "#nosotros" },
                { label: "Misión y Valores", href: "#mision" },
                { label: "Cursos y Diplomados", href: "#cursos" },
                { label: "Próximos Cursos", href: "#proximos-cursos" },
                { label: "Videos TikTok", href: "#tiktok" },
                { label: "Testimonios", href: "#testimonios" },
                { label: "Ubicación", href: "#ubicacion" },
              ].map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => handleNav(l.href)}
                    className="text-gray-500 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#0A1F44] font-bold text-sm uppercase tracking-widest mb-5">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-[#D4AF37] text-base mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-500 text-sm">Juan Kepler 4052A, Arboledas, Zapopan, Jalisco, CP 45070</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-[#D4AF37] text-base flex-shrink-0"></i>
                <a href="tel:+523325077743" className="text-gray-500 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">
                  +52 33 2507 7743
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-[#D4AF37] text-base flex-shrink-0"></i>
                <a href="mailto:contacto@ashaika.com" className="text-gray-500 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">
                  contacto@ashaika.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#D4AF37]/20 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 Instituto Ashaika. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer" rel="nofollow">Aviso de Privacidad</a>
            <span className="text-gray-300">|</span>
            <a href="#" className="text-gray-400 text-sm hover:text-[#D4AF37] transition-colors cursor-pointer" rel="nofollow">Términos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
